<template>
  <!-- Cart Items -->
  <div class="cart-item">
    <div class="d-flex flex-column flex-lg-row align-items-lg-center">
      <!-- Registrant & Event -->
      <RegistrantAndEvent
        class="flex-fill text-lg-left text-center"
        :registration="registration"
      />
      <!-- / Registrant & Event -->

      <!-- Cost Summary -->
      <div class="mt-3 mt-lg-0 text-right mx-auto">
        <CostSummary
          class="d-flex justify-content-center justify-content-lg-end"
          :registration="registration"
        />

        <!-- Apply Promo Code -->
        <form
          style="width: 220px;"
          class="mr-lg-0 ml-lg-auto mx-auto mt-3"
          @submit.prevent="applyPromoCode({ [registration.id]: promoCode })">
          <b-input-group>
            <b-form-input
              name="promoCode"
              type="text"
              placeholder="Enter Promo Code"
              v-model="promoCode"
              :disabled="submitting">
            </b-form-input>
            <b-input-group-append>
              <b-button
                variant="primary"
                type="submit"
                :disabled="submitting">
                Apply
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </form>
        <!-- / Apply Promo Code -->

        <!-- Remove Registration -->
        <b-button
          class="mr-lg-0 ml-lg-auto mx-auto d-block mt-3"
          type="button"
          variant="danger"
          @click="$emit('remove-registration', registration.id)"
          :disabled="requestActive">
          Remove Registrant
        </b-button>
        <!-- / Remove Registration -->

        <div
          class="mt-3 text-center text-lg-left"
          v-if="this.registration.state === 'waitlist'">
          *Payment due when moved to Active Roster
        </div>
      </div>
      <!-- / Cost Summary -->
    </div>
    <hr>
  </div>
  <!-- / Cart Items -->
</template>

<script>
import _ from 'lodash';
import DataSvc from '../services/data';
import AppMixin from '../services/mixin.app';

export default {
  name: 'cart-item',
  props: [
    'registration',
  ],
  mixins: [AppMixin],
  data() {
    return {
      submitting: false,
      promoCode: this.registration.promo_code
        ? this.registration.promo_code.code
        : null,
    };
  },
  methods: {
    applyPromoCode(promoCode) {
      _.each(promoCode, (code, registrationID) => {
        if (!code) {
          promoCode[registrationID] = null;
        }
      });

      this.showGlobalLoader('Applying Promo Code...');
      this.submitting = true;

      return DataSvc.applyPromoCode(this.registrationSession.uuid, promoCode)
        .then(this.updateActiveRegistrationSession)
        .finally(() => {
          this.hideGlobalLoader();
          this.submitting = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
